<template v-cloak>
  <SkeletonCards v-if="!finishedInitialLoading" :amount="perPage"/>
  <Card
      v-else-if="incidents.length > 0"
      v-for="post in incidents"
      :key="post.id"
      :post="post"
  />
</template>

<script>
import { defineComponent, ref, onMounted, onBeforeMount, provide } from 'vue';

import Card from "./components/Card.vue";
import SkeletonCards from "./components/SkeletonCards.vue";

export default defineComponent( {
  name: 'IncidentHeroCards',
  components: {
    Card,
    SkeletonCards
  },
  props: {
    perPage: {
      type: Number,
      default: 3,
    },
    updateInterval: {
      type: Number,
      default: 60,
    },
    chipLabels: {
      type: Object,
      default: () => ( {
        active: 'Active',
        inactive: 'Resolved',
      } ),
    },
    defaultIncidents: {
      type: Array,
      default: () => [],
    },
  },
  setup( props ) {
    const finishedInitialLoading = ref( false );
    const incidents = ref( [ ...props.defaultIncidents ] );
    const language = ref( document.documentElement.lang || navigator.language );

    provide( 'language', language );

    // Pass data to the chips directly.
    provide( 'chipLabels', props.chipLabels );

    provide( 'card_heading_level', 3 );

    const fetchIncidents = async () => {
      try {
        const { url, route } = window.vrgz_variables.rest;
        await fetch( `${ url }${ route }/incidents?per_page=${ props.perPage }&compact=1` )
            .then( response => {
              if ( ! response.ok ) {
                throw new Error( 'Network response was not ok' );
              }
              return response.json();
            } )
            .then( data => incidents.value = data )
            .finally( () => finishedInitialLoading.value = true )
            .catch( error => console.error( 'Error fetching comments:', error ) );
      } catch ( error ) {
        console.error( 'Error fetching comments:', error );
      }
    };

    onBeforeMount( fetchIncidents );
    onMounted( () => {
      setInterval( fetchIncidents, props.updateInterval * 1000 )
    } );

    return {
      finishedInitialLoading,
      incidents,
      title: props.title,
    };
  },
} );
</script>
